exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".disabled{color:#767676!important;cursor:not-allowed}.disabled:hover{color:#767676;background-color:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/common/DisableableLink/index.scss
// module id = 1011
// module chunks = 0